import React, { useEffect, useState } from "react";
import "./../Styles/ViewDesign.css";
import { API, UPLOADS } from "./../../config/api";
export default function ViewDesign() {
  const [designs, setDesigns] = useState([]);
  const [editData, setEditData] = useState(null);
  const categories = ["Malti", "Sequience", "Cording", "Chain", "Beads"];

  /* ================= FILTER STATES ================= */
  const [search, setSearch] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");

  useEffect(() => {
    fetchDesigns();
  }, []);

  const fetchDesigns = async () => {
    try {
      const res = await fetch(API.LIST_ALL_DESIGNS);
      const data = await res.json();

      if (data.status) {
        setDesigns(data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  /* ================= FILTER ================= */

  const filteredDesigns = designs.filter((d) => {
    const categoryMatch =
      selectedCategory === "all" || d.category === selectedCategory;

    const searchMatch =
      d.design_code?.toLowerCase().includes(search.toLowerCase()) ||
      d.id?.toString().includes(search);

    return categoryMatch && searchMatch;
  });

  /* ================= DELETE ================= */

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this design?")) return;

    const formData = new FormData();
    formData.append("id", id);

    const res = await fetch(API.DELETE_DESIGN, {
      method: "POST",
      body: formData,
    });

    const data = await res.json();
    alert(data.message);
    fetchDesigns();
  };

  /* ================= EDIT ================= */

  const handleEdit = (design) => {
    setEditData(design);
  };

  const handleUpdate = async () => {
    const formData = new FormData();

    formData.append("id", editData.id);
    formData.append("category", editData.category);
    formData.append("design_code", editData.design_code);
    formData.append("stitch", editData.stitch);
    formData.append("area", editData.area);
    formData.append("color", editData.color);

    if (editData.jpeg_file) formData.append("jpeg_file", editData.jpeg_file);
    if (editData.emb_file) formData.append("emb_file", editData.emb_file);

    const res = await fetch(API.UPDATE_DESIGN, {
      method: "POST",
      body: formData,
    });

    const data = await res.json();
    alert(data.message);

    setEditData(null);
    fetchDesigns();
  };

  return (
    <div className="dashboard-content px-4 py-4">
      {/* ================= FILTER ================= */}

      <div className="filter-wrapper mb-4">
        <h2 className="machine-title">All Designs</h2>

        <div className="filter-controls">
          <select
            className="form-select"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            <option value="all">All Categories</option>

            {categories.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>

          <input
            type="text"
            className="form-control"
            placeholder="Search Design Code..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </div>

      {/* ================= TABLE ================= */}

      <div className="table-responsive">
        <table className="machine-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Category</th>
              <th>Code</th>
              <th>Stitch</th>
              <th>Area</th>
              <th>Color</th>
              <th>JPEG</th>
              <th>EMB</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredDesigns.length > 0 ? (
              filteredDesigns.map((design, index) => (
                <tr key={design.id}>
                  <td data-label="#">{index + 1}</td>

                  <td data-label="Category">{design.category}</td>

                  <td data-label="Code">{design.design_code}</td>

                  <td data-label="Stitch">{design.stitch}</td>

                  <td data-label="Area">{design.area}</td>

                  <td data-label="Color">{design.color}</td>

                  <td data-label="JPEG">
                    <a
                      href={`${UPLOADS.DESIGN_IMAGE}${design.jpeg_file}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      View
                    </a>
                  </td>

                  <td data-label="EMB">
                    <a
                      href={`${UPLOADS.DESIGN_IMAGE}${design.emb_file}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Download
                    </a>
                  </td>

                  <td>
                    <button
                      className="btn btn-warning btn-sm me-2"
                      onClick={() => handleEdit(design)}
                    >
                      Edit
                    </button>

                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDelete(design.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center py-3">
                  No Designs Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ================= EDIT MODAL ================= */}

      {editData && (
        <div className="modal show d-block modal-overlay">
          <div className="modal-dialog modal-lg">
            <div className="modal-content p-4">
              <h4>Edit Design</h4>

              <div className="row">
                <div className="col-md-6">
                  <label>Category</label>

                  <select
                    className="form-control mb-3"
                    value={editData.category}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        category: e.target.value,
                      })
                    }
                  >
                    {categories.map((cat) => (
                      <option key={cat}>{cat}</option>
                    ))}
                  </select>

                  <label>Design Code</label>

                  <input
                    className="form-control mb-3"
                    value={editData.design_code}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        design_code: e.target.value,
                      })
                    }
                  />

                  <label>Stitch</label>

                  <input
                    className="form-control mb-3"
                    value={editData.stitch}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        stitch: e.target.value,
                      })
                    }
                  />

                  <label>Area</label>

                  <input
                    className="form-control mb-3"
                    value={editData.area}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        area: e.target.value,
                      })
                    }
                  />

                  <label>Color</label>

                  <input
                    className="form-control mb-3"
                    value={editData.color}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        color: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="col-md-6">
                  <label>JPEG</label>

                  <input
                    type="file"
                    className="form-control mb-3"
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        jpeg_file: e.target.files[0],
                      })
                    }
                  />

                  {editData.jpeg_file &&
                    typeof editData.jpeg_file === "string" && (
                      <img
                        src={`${UPLOADS.DESIGN_IMAGE}${editData.jpeg_file}`}
                        width="120"
                        alt=""
                      />
                    )}

                  <label className="mt-3">EMB</label>

                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        emb_file: e.target.files[0],
                      })
                    }
                  />
                </div>
                <div className="modal-actions">
                  <button className="btn btn-success" onClick={handleUpdate}>
                    Update
                  </button>

                  <button
                    className="btn btn-secondary"
                    onClick={() => setEditData(null)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
